(function(angular){
	'use strict';
	
	angular
		.module('iconModule', [])
		.constant('ICON_MAP', {
			"alert-error-32x32" : "/static/html/shared/icon/alert-error-32x32.html",
			"alert-info-32x32" : "/static/html/shared/icon/alert-info-32x32.html",
			'alert-success-32x32' : '/static/html/shared/icon/alert-success-32x32.html',
			'alert-warning-32x32' : '/static/html/shared/icon/alert-warning-32x32.html',
			'balanced-investing-lg' : '/static/html/shared/icon/balanced-investing-lg.html',
			'balanced-investing' : '/static/html/shared/icon/balanced-investing.html',
			'caret-down' : '/static/html/shared/icon/caret-down.html',
			'caret-up' : '/static/html/shared/icon/caret-up.html',
			'document' : '/static/html/shared/icon/document.html',
			'facebook' : '/static/html/shared/icon/facebook.html',
			'fund-phase-operating-16x16' : '/static/html/shared/icon/fund-phase-operating-16x16.html',
			'fund-phase-operating-24x24' : '/static/html/shared/icon/fund-phase-operating-24x24.html',
			'fund-phase-ramping-up-16x16' : '/static/html/shared/icon/fund-phase-ramping-up-16x16.html',
			'fund-phase-ramping-up-24x24' : '/static/html/shared/icon/fund-phase-ramping-up-24x24.html',
			'fund-phase-stabilizing-16x16' : '/static/html/shared/icon/fund-phase-stabilizing-16x16.html',
			'fund-phase-stabilizing-24x24' : '/static/html/shared/icon/fund-phase-stabilizing-24x24.html',
			'gear' : '/static/html/shared/icon/gear.html',
			'grid' : '/static/html/shared/icon/grid.html',
			'invite-program-envelope' : '/static/html/shared/icon/invite-program-envelope.html',
			'linkedin' : '/static/html/shared/icon/linkedin.html',
			'list' : '/static/html/shared/icon/list.html',
			'lock' : '/static/html/shared/icon/lock.html',
			'long-term-growth-lg' : '/static/html/shared/icon/long-term-growth-lg.html',
			'long-term-growth' : '/static/html/shared/icon/long-term-growth.html',
			'map' : '/static/html/shared/icon/map.html',
			'modal-close' : '/static/html/shared/icon/modal-close.html',
			'paperclip' : '/static/html/shared/icon/paperclip.html',
			'plan-balanced-investing-24x24' : '/static/html/shared/icon/plan-balanced-investing-24x24.html',
			'plan-long-term-growth-24x24' : '/static/html/shared/icon/plan-long-term-growth-24x24.html',
			'plan-starter-24x24' : '/static/html/shared/icon/plan-starter-24x24.html',
			'plan-supplemental-income-24x24' : '/static/html/shared/icon/plan-supplemental-income-24x24.html',
			'starter-portfolio-lg' : '/static/html/shared/icon/starter-portfolio-lg.html',
			'starter-portfolio' : '/static/html/shared/icon/starter-portfolio.html',
			'supplemental-income-lg' : '/static/html/shared/icon/supplemental-income-lg.html',
			'supplemental-income' : '/static/html/shared/icon/supplemental-income.html',
			'twitter' : '/static/html/shared/icon/twitter.html'
		});

})(window.angular);